import qs from 'qs';
import { network } from 'services/network';

export const uploadUserImageByUserName = (params) => {
    const querystring = qs.stringify({ userName: params.userName }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/uploadUserImageByUserName${querystring}`;
    const formData = new FormData();
    if (params.file !== null) {
        if (typeof params.file.size !== 'undefined') {
            formData.append('file', params.file, params.file.name);
        }
    }
    return network
        .post(url, formData, {
            transformRequest: [
                (data, headers) => {
                    if (headers) {
                        headers['Content-Type'] = 'multipart/form-data';
                    }
                    return data;
                },
            ],
        })
        .then((response) => {
            response.data;
        });
};
